import React from 'react';
import styles from './EmbeddedStyles.css';

/**
  EmbeddedStyles Component
*/
const EmbeddedStyles = ({ children }) => (
    <div className="embedded-styles">
        {children}
        <style jsx>{styles}</style>
    </div>
);

export default EmbeddedStyles;

// make this take a child component to make content sections



// WEBPACK FOOTER //
// ./src/components/EmbeddedStyles/EmbeddedStyles.js